import React, { useState, useEffect } from 'react';
import { Snackbar, Alert } from '@mui/material';

/**
 * Global rate limit error notification component
 * Listens for rate limit errors dispatched by axios interceptor
 */
const RateLimitNotification = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const handleRateLimitError = (event) => {
      setMessage(event.detail.message);
      setOpen(true);
    };

    // Add event listener
    window.addEventListener('rateLimitError', handleRateLimitError);

    // Cleanup function to remove event listener when component unmounts
    // This prevents memory leaks and duplicate listeners
    return () => {
      window.removeEventListener('rateLimitError', handleRateLimitError);
    };
  }, []); // Empty dependency array ensures this runs only once on mount

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={8000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ top: { xs: 70, sm: 24 } }}
    >
      <Alert
        severity="warning"
        onClose={handleClose}
        sx={{ minWidth: 300 }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default RateLimitNotification;
